var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestinationPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H12.5714C18.8833 0 24 5.11675 24 11.4286V12.5714C24 18.8833 18.8833 24 12.5714 24H12C5.37258 24 0 18.6274 0 12Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H13V31C13 31.5523 12.5523 32 12 32C11.4477 32 11 31.5523 11 31V24Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM8.59961 8.37305V16.124H11.7471C14.0833 16.124 15.4637 14.6789 15.4639 12.2031V12.1924C15.4639 9.72705 14.0835 8.37305 11.7471 8.37305H8.59961ZM11.4893 9.96289C12.73 9.96289 13.4609 10.7471 13.4609 12.1973V12.208C13.4609 13.7549 12.7729 14.5342 11.4893 14.5342H10.5713V9.96289H11.4893Z",
    fill: "#9664F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationPending);
export default __webpack_public_path__ + "static/media/destination-pending.bddc58196418562dca277e91d9bb7885.svg";
export { ForwardRef as ReactComponent };